import { render, staticRenderFns } from "./IconoHeader.vue?vue&type=template&id=fa002fe2&scoped=true&"
import script from "./IconoHeader.vue?vue&type=script&lang=js&"
export * from "./IconoHeader.vue?vue&type=script&lang=js&"
import style0 from "./IconoHeader.vue?vue&type=style&index=0&id=fa002fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa002fe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
